module.exports = __webpack_public_path__ + "static/img/11.7e7bd2f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/zh/11.png
// module id = Jcw/
// module chunks = 0